var common = require('./common');

module.exports = {
    isLogin:function(router){
        var $this = this;
        setTimeout(function () {
            common.fetch("/auth/isLogin", {
                success: function (data) {
                    // 初始化Profile
                    if(data.data){
                        $this.getUser(router);
                    }else{
                        if(data.redirectUrl){
                            common.redirectTo(data.redirectUrl);
                        }else{
                            router.redirect("#/login" + location.search)
                        }
                    }
                }
            });
        }, 300)
    },
    getUser:function(router){
        setTimeout(function () {
            common.fetch("/auth/getUser", {
                handleError: function (data) {
                    if (common.browserInfo().name === "MSIE" && common.browserInfo().version <= 9) {
                        router.redirect("#/login" + location.search)
                    } else {
                        common.redirectTo("/#/login" + location.search)
                    }
                },
                success: function (data) {
                    // 初始化Profile
                    common.initStorage(data.data);
                    common.redirectTo("/#/appList")
                }
            });
        }, 300)
    },
    ccbLogin:function(router){
        var $this = this;
        var t = common.urlSearch(location.href)["st"];
        if(t){
            common.fetch("/auth/ccbLogin?st="+t, {
                handleError: function (data) {
                },
                success: function (data) {
                    $this.getUser(router);
                }
            });
        }else{
            this.isLogin(router);
        }   
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/utiles/routerUtils.js
// module id = 174
// module chunks = 0